import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { Observer } from './api/socket'
import { ObserverProvider } from './lib/ObserverProvider'
import { fromLegacyHash } from './lib/routes'
import './index.css'

// Before the router sees the URL, not after: `BrowserRouter` reads
// `location.pathname` on mount and would otherwise render the front page while
// the fragment sat in the address bar, unread and unexplained.
const migrated = fromLegacyHash(window.location.hash)
if (migrated) window.history.replaceState(null, '', migrated)

// One socket per tab, created here rather than inside a component so React 19's
// double-invoked StrictMode effects cannot open two.
const observer = new Observer()

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <ObserverProvider observer={observer}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ObserverProvider>
  </StrictMode>,
)
